/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The cluster slot this plan was recommended from.
 */
export enum RankKey {
  lowestCost = 'lowestCost',
  lowestRisk = 'lowestRisk',
  bestCoverage = 'bestCoverage',
  bestAllInCost = 'bestAllInCost',
}
